import ImageElement from './ImageElement';
import H1Element from './H1Element';
import H2Element from './H2Element';
import H3Element from './H3Element';
import PElement from './PElement';
import SingleChoiceElement from './SingleChoiceElement';
import GridChoiceElement from './GridChoiceElement';
import HorizontalSingleChoiceElement from './HorizontalSingleChoiceElement';
import MarkdownElement from './MarkdownElement';
import ButtonElement from './ButtonElement';
import GraphElement from './GraphElement';
import TypingTextElement from './TypingTextElement';
import LoadingBarsElement from './LoadingBarsElement';
import ReviewsHorizontalElement from './ReviewsHorizontalElement';
import ReviewsVerticalElement from './ReviewsVerticalElement';
import OptionsElement from './OptionsElement';
import ListWithIconsElement from './ListWithIconsElement';
import EmailInputElement from './EmailInputElement';
import FloatingTimerElement from './FloatingTimerElement';
import PaywallItemsElement from './PaywallItemsElement';
import PaymentFormElement from './PaymentFormElement';
import SpecialOfferElement from './SpecialOfferElement';
import ListElement from './ListElement';
import IconTextElement from './IconTextElement';
import ProgressBarElement from './ProgressBarElement';

const elementRegistry = {
    image: ImageElement,
    h1: H1Element,
    h2: H2Element,
    h3: H3Element,
    p: PElement,
    singleChoice: SingleChoiceElement,
    gridChoice: GridChoiceElement,
    horizontalSingleChoice: HorizontalSingleChoiceElement,
    markdown: MarkdownElement,
    button: ButtonElement,
    graph: GraphElement,
    'typing-text': TypingTextElement,
    loadingBars: LoadingBarsElement,
    reviewsHorizontal: ReviewsHorizontalElement,
    reviewsVertical: ReviewsVerticalElement,
    options: OptionsElement,
    listWithIcons: ListWithIconsElement,
    emailInput: EmailInputElement,
    floatingTimer: FloatingTimerElement,
    paywallItems: PaywallItemsElement,
    paymentForm: PaymentFormElement,
    specialOffer: SpecialOfferElement,
    list: ListElement,
    iconText: IconTextElement,
    progressBar: ProgressBarElement,
};

export default elementRegistry;
